import type { QueryClient } from '@tanstack/react-query';
import { setMockTransport } from '@/lib/api/mock-transport';
import { canUseMockMode, mockModePreferred } from '@/lib/mock-mode';

let installed = false;

/**
 * Puts the API client in or out of mock mode for whoever is signed in (the
 * signed-in guard calls it before anything reads the team). The mock world is
 * loaded only when it is on. Changing over drops the query cache, so real and
 * invented data never mix. Resolves to whether mock mode is on.
 */
export async function syncMockMode(email: string, queryClient: QueryClient): Promise<boolean> {
  const on = canUseMockMode(email) && mockModePreferred();
  if (on === installed) return on;
  if (on) {
    const { installMocks } = await import('@/mocks');
    installMocks();
  } else {
    setMockTransport(null);
  }
  installed = on;
  queryClient.clear();
  return on;
}
